import { adminNotificationConstants as C } from "../actions/constants";

const initial = {
    notifications: [],
    nextCursor: null,
    hasMore: true,
    loading: false,
    filters: {
        from: null,  // 'YYYY-MM-DD'
        to: null,    // 'YYYY-MM-DD'
        sort: "desc",
        limit: 15,
    },
};

export default function adminNotifications(state = initial, action) {
    switch (action.type) {
        case C.SET_FILTERS:
            return {
                ...state,
                filters: { ...state.filters, ...action.payload },
            };

        case C.RESET_LIST:
            return {
                ...state,
                notifications: [],
                nextCursor: null,
                hasMore: true,
            };

        case C.FETCH_PAGE_SUCCESS: {
            const { items, nextCursor, hasMore } = action.payload;

            // антидубликат по _id
            const existing = new Set(state.notifications.map(n => String(n._id)));
            const merged = [
                ...state.notifications,
                ...items.filter(n => !existing.has(String(n._id))),
            ];

            return {
                ...state,
                notifications: merged,
                nextCursor,
                hasMore,
            };
        }

        case C.RECEIVED: {
            const n = action.payload;
            if (state.notifications.some(x => String(x._id) === String(n._id))) {
                return state;
            }
            // новые всегда в начало — для sort=desc это корректно
            return { ...state, notifications: [n, ...state.notifications] };
        }

        case C.MARK_READ:
            return {
                ...state,
                notifications: state.notifications.map(n =>
                    n._id === action.payload ? { ...n, isRead: true } : n
                ),
            };

        default:
            return state;
    }
}
